import {  Sell } from "@mui/icons-material";
import dayjs from '../../utils/dayjs-setup';
import { Button, GridLegacy as Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance, DateFormatString, FormActions, FormatPrice,  usuarioEntity } from "../../utils/constants";
import * as yup from "yup";
import { ModalComprarCotizaciones,} from "../../components/form/ModalForm";
import { FilterForm } from "../../components/form/filter-form";








const schemaFilter = yup.object({
  

}).required();

const schema = yup.object({
  usuario: yup.string().required(),
  razon_social: yup.string().required(),
  celular: yup.number().required(),
  email: yup.string().email().required(),
  pass: yup.string().optional(),
  perfil: yup.number().required(),
  productos_asociados: yup.array().of(
    yup.object().shape({
      label:yup.string(),
      value:yup.number()
    })
  ).optional(),
  centro_op_destinos: yup.array().of(
    yup.object().shape({
      label:yup.string(),
      value:yup.number()
    })
  ).optional().notRequired().nullable(),
  activo: yup.bool().required(),
}).required();
const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:"",
  producto:null,
  proveedor:null
};

export const MisCotizaciones = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store:{profile}} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({...usuarioEntity});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [productosOptions,setProductosOptions] = useState([]);
  const [proveedorOptions,setProveedorOptions] = useState([]);



    useEffect(()=>{

      
      loadInitData();

    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      await loadItems(false);
   
     

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }

    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("cotizaciones/obtener-cotizaciones-recibidas",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value.data]);

     setTotalRows(value.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };

    const onShowDetailProduct = (cod_prod)=>{
      setIsVisibleModalDetalle(true);
      let product =  dataSetProdctos.find(prod=>prod.cotizacion_cod === cod_prod);
      setProductoSeleccionado(product || {});
     
    }
    const onHideDetailProduct = ()=>{
      setIsVisibleModalDetalle(false);
      setProductoSeleccionado({});
    }

    const onOpenModalItem = (edit=false)=>{
      if (!edit){
        setProductoSeleccionado({...usuarioEntity});
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }


    const onSearchProveedor = async (evt,value_search) => {

      if (value_search && value_search.length > 3) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-prov-by-filter", {
            search_query: value_search
          });
          setProveedorOptions(value);
          return value;
         }catch(e){
          return [];
         }
  
      }
  
  
  
    }

    const onSearchProducto = async (value_search) => {

      if (value_search && value_search.length > 3) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter", {
            search_query: value_search
          });
          return value
       
         
         }catch(e){
          return [];
         }
  
      }
  
  
  
    }

    const searcProductoAsociado = async (event, newInputValue) => {
      try {
        let res = await onSearchProducto(newInputValue);
        console.log({res});
        setProductosOptions(res);
      } catch (e) {
  
      }
    }

    const  setFilterAply = (filtros)=>{
      console.log({filtros});
      setFilterSearchPagination({
        ...filterSearchPagination,
        page_number:0,
        producto:filtros.producto?.value,
        proveedor:filtros.proveedor?.value
      });
     
    }

  
    const columnsTable = [
      {
      
       key:"cotizacion_cod",
       keyValue:"cotizacion_cod",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
      {
        key:"razon_social",
        keyValue:"razon_social",
        label:"Proveedor",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"cotizacion_origen_name",
        keyValue:"cotizacion_origen_name",
        label:"Origen",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"cotizacion_destino_name",
        keyValue:"cotizacion_destino_name",
        label:"Punto de entrega",
        headerRender:(props)=>props.label,
        bodyRender: (props) => props.value || 'Recoger en finca',
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"nombre_producto",
        keyValue:"nombre_producto",
        label:"Producto",
        headerRender:(props)=>props.label,
        bodyRender:({value,info})=>`${info.cod_erp_producto}-${value}`,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
    
       {
      
        key:"cotizacion_cantidad",
        keyValue:"cotizacion_cantidad",
        label:"Cantidad Ofertada",
        headerRender:(props)=>props.label,
        bodyRender:(props)=> `${FormatPrice(props.value)} ${props.info.nombre_unidad_medida}(S) `,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"cotizacion_precio_un",
        keyValue:"cotizacion_precio_un",
        label:"Precio oferta",
        headerRender:(props)=>props.label,
        bodyRender:(props)=> `${FormatPrice(props.value)} / ${props.info.nombre_corto_unidad_medida}`,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"total_kg_ofertado",
        keyValue:"total_kg_ofertado",
        label:"Total KG",
        headerRender:(props)=>props.label,
        bodyRender:(props)=> `${FormatPrice(props.value)}`,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       
       {
        
        key:"vigencia",
        keyValue:"vigencia",
        label:"Vigencia",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>`${dayjs(props.info.cotizacion_fecha_desde).format(DateFormatString)} | ${dayjs(props.info.cotizacion_fecha_hasta).format(DateFormatString)}`,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
        key:"editar",
        keyValue:"cotizacion_cod",
        label:"Comprar",
        headerRender:(props)=>props.label,
        bodyRender:({value})=><IconButton onClick={e=>onShowDetailProduct(value)} color="primary" aria-label="Ver producto" ><Sell/></IconButton>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
      },  
    ];
   
    const InputFilters = [
      {
        grid:{
          xs:4,
          md:4,
          sm:4
        },
        InputComponent:AutoCompleteInputWithLabel,
        keyValue:"producto",
        InputComponentProps:{
          label:"Producto",
          fullWidth: true,
          isLoading: false,
          multiple:false,
          size:'small',
      /*     PopperComponent:(props)=><div hidden={!props.open} >
           
             {props.children}
          </div>, */
          onInputChange: searcProductoAsociado,
          options: productosOptions || [],
          noOptionsText: "Lista vacia",
          getOptionLabel: (option) => option.label,
          isOptionEqualToValue: (option, value) => option.value === value.value,
          filterOptions:(x) => x,
        }
      },
      {
        grid:{
          xs:4,
          md:4,
          sm:4
        },
        InputComponent:AutoCompleteInputWithLabel,
        keyValue:"proveedor",
        InputComponentProps:{
          label:"proveedor",
          fullWidth: true,
          isLoading: false,
          multiple:false,
          size:'small',
          onInputChange: onSearchProveedor,
          options: proveedorOptions || [],
          noOptionsText: "Lista vacia",
          getOptionLabel: (option) => option.label,
          isOptionEqualToValue: (option, value) => option.value === value.value,
          filterOptions:(x) => x,
        }
      },
     
      ];

    return (<>
      
      {
       isVisibleModalDetalle && 
       <ModalComprarCotizaciones 
       opened={isVisibleModalDetalle}
       onCloseModal={onHideDetailProduct}
       cotizacionInfo={productoSeleccionado}
       />
      }
   
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={4} >

        <FilterForm
            buttomDist={
              {
                sx:3,
                md:3
              }
            }
            nameFilter={"Buscar necesidades por"}
            inputsFilter={InputFilters}
            schemaValidator={schemaFilter}
            initialValuesFilter={
            {  producto:InitialFilterSearch?.producto,
              proveedor:InitialFilterSearch?.proveedor,
              
             
             }
            }
            onApplyFilter={setFilterAply}
          />

        </Grid>
        <Grid item sm={12} xs={12} md={12} >
          <Button variant="contained" color="primary" onClick={e=>onOpenModalItem(false)} >Nuevo usuario</Button>
        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender key={prod.key} value={prod[Col.keyValue]} info={prod} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}